"use client";

import { useCallback } from "react";
import { useRouter } from "@/i18n/navigation";
import { useTranslations } from "next-intl";
import { AutocompleteSearchBar } from "@/components/search/autocomplete-search-bar";

export function ProjectsAllSearch() {
  const router = useRouter();
  const t = useTranslations("projects");

  const handleSubmit = useCallback(
    (term: string) => {
      if (!term.trim()) return;
      router.push(`/projects?search=${encodeURIComponent(term.trim())}`);
    },
    [router],
  );

  return (
    <AutocompleteSearchBar
      sources={["projects"]}
      onSubmit={handleSubmit}
      placeholder={t("allProjects.searchPlaceholder")}
    />
  );
}
